function Footer(props){
    return (
        <div className="footer">
            Designed by Kenneth Kiang.
        </div>
    )
}

export default Footer;